import { createClient } from "@connectrpc/connect";
import { createConnectTransport } from "@connectrpc/connect-web";
import { ChordSheetService } from "../gen/proto/chordsheet/v1/chordsheet_pb";
import { BackendConfig } from "../Config";

export interface ParsingError {
  message: string;
  lineNumber?: number;
}

export interface LyricsPart {
  label?: string;
  content: string;
  type?: string;
  indexByTypeOneBased: number;
}

// Create a Connect client
const transport = createConnectTransport({
  baseUrl: BackendConfig.chordsheetjsProxyUrl,
});

const client = createClient(ChordSheetService, transport);

export async function getLyricsParts(
  chordsheet: string,
): Promise<LyricsPart[] | ParsingError> {
  if (!chordsheet) {
    return [];
  }
  try {
    const response = await client.getLyricsParts({ chordsheet });
    if (response.result.case === "failure") {
      return {
        message: response.result.value.errorMessage,
        lineNumber: response.result.value.errorLine,
      };
    }
    if (response.result.case === "success") {
      return response.result.value.parts.map((part) => ({
        label: part.label || undefined,
        content: part.content,
        type: part.type || undefined,
        indexByTypeOneBased: part.indexByTypeOneBased,
      }));
    }
    return [];
  } catch (error: unknown) {
    const message =
      error instanceof Error ? error.message : "Failed to fetch lyrics parts";
    return { message };
  }
}
